import { gql } from "../../../lib/Apollo"

export const LOAD = gql`
  query getBusinessInformationProfile($key: String!, $awardYear: String) {
    getBusinessInformationProfile(companyNameKey: $key, awardYear: $awardYear) {
      happinessScores {
        industry
        score
        global
      }
      companyNameKey
      surveyCompanyId
      profile {
        organisationId
        id
        active
        status
        summary {
          banner
          name
          size
          websiteURL
          logoUrl
          services
          contactEmail
          videos
          industry {
            id
          }
          awardsLogo
          foundedAt
          locations {
            city
            country {
              id
            }
          }
          social {
            linkedIn
            twitter
            youtube
            pinterest
            facebook
            instagram
          }
        }
        culture {
          statement
          shortStatement
        }
      }
    }
  }
`

export const GET_DUNNS_DATA_BY_KEY = gql`
  query ($companyNameKey: String!) {
    getCompany(companyNameKey: $companyNameKey) {
      companyName
      companyNameKey
      employeesInfo {
        totalEmployees
      }
      industries
      country
      businessInfo {
        address {
          street1
          street2
          stateProvince
          postalCode
          country
          city
        }
        businessLine
        establishmentYear
        name
      }
      headquarterInfo {
        address {
          city
          country
          postalCode
          stateProvince
          street1
          street2
        }
      }
    }
  }
`

export const GET_AWARDS_WINS = gql`
  query getAwardWins($companyNameKey: String) {
    getAwardWins(companyNameKey: $companyNameKey) {
      logoUrls
      awardWins
      happinessScore
      sundayTimesAward
      year
      __typename
    }
  }
`

export const GET_COMPANY_MARKS = gql`
  query ($companyNameKey: String!) {
    getCompanyMarks(companyNameKey: $companyNameKey) {
      accreditationUrl
      charterMarkUrl
      __typename
    }
  }
`
